export default "__VITE_ASSET__DGQarqRO__"